import { DEFAULT_DECIMAL_PRECISION } from '@thoughtspot/number-format-util';
import _ from 'lodash';
import { CategoryType, } from '../types/prism';
export const NULL_SUMMARY_MODE = 'None';
export const DEFAULT_PERCENTAGE_FORMAT = {
    __typename: 'FormatConfig',
    category: CategoryType.Percentage,
    isCategoryEditable: false,
    currencyFormatConfig: null,
    customFormatConfig: null,
    numberFormatConfig: null,
    percentageFormatConfig: {
        __typename: 'PercentageFormatConfig',
        decimals: DEFAULT_DECIMAL_PRECISION,
        removeTrailingZeroes: false,
    },
};
const categoryToFormatDetailsKey = {
    [CategoryType.Number]: 'numberFormatConfig',
    [CategoryType.Currency]: 'currencyFormatConfig',
    [CategoryType.Percentage]: 'percentageFormatConfig',
    [CategoryType.Custom]: 'customFormatConfig',
};
export const compareNumberFormats = (formatA, formatB) => {
    if (_.isNil(formatA) && _.isNil(formatB)) {
        return 0;
    }
    if (_.isNil(formatA)) {
        return 1;
    }
    if (_.isNil(formatB)) {
        return -1;
    }
    if (formatA.unit > formatB.unit) {
        return -1;
    }
    if (formatA.unit < formatB.unit) {
        return 1;
    }
    if (formatA.decimals > formatB.decimals) {
        return -1;
    }
    if (formatA.decimals < formatB.decimals) {
        return 1;
    }
    return 0;
};
const getCategory = (formatConfig) => formatConfig.category;
const getFormatConfigDetailsKey = (formatConfig) => categoryToFormatDetailsKey[getCategory(formatConfig)];
export const getUnit = (formatConfig) => _.get(formatConfig, `${getFormatConfigDetailsKey(formatConfig)}.unit`, undefined);
export const getNegativeValueFormat = (formatConfig) => _.get(formatConfig, `${getFormatConfigDetailsKey(formatConfig)}.negativeValueFormat`, undefined);
export const hasUnit = (formatConfig) => !!getUnit(formatConfig);
export const setUnit = (formatConfig, unit) => _.set(formatConfig, `${getFormatConfigDetailsKey(formatConfig)}.unit`, unit);
export const hasNegativeValueFormat = (formatConfig) => !!getNegativeValueFormat(formatConfig);
export const setNegativeValueFormat = (formatConfig, negativeValueFormat) => _.set(formatConfig, `${getFormatConfigDetailsKey(formatConfig)}.negativeValueFormat`, negativeValueFormat);
export const getDecimals = (formatConfig) => _.get(formatConfig, `${getFormatConfigDetailsKey(formatConfig)}.decimals`, undefined);
export const setDecimals = (formatConfig, decimals) => _.set(formatConfig, `${getFormatConfigDetailsKey(formatConfig)}.decimals`, decimals);
//# sourceMappingURL=format-config-util.js.map